function List({items = []}) {
    var jsxItems = items.map((a, index) => <li key={index}>{a}</li>)
    return <ul>{jsxItems}</ul>
}

export default List;